import classNames from "classnames";
import React from "react";
import { withRouter } from "react-router-dom";

import { ModuleContext } from "../components/authProvider/main";
import DashboardCustomization from "../components/dashboardCustomization/dashboardCustomization";

class DashboardPage extends React.Component<any, {}> {
  static contextType = ModuleContext;

  public state = {
    module: null,
  };

  componentDidMount() {
    (this.context as any).setPage("/dashboard/{module}");
  }

  render() {
    const { module } = this.props.match.params;
    const modulesLocal: any = localStorage.getItem("modules");
    const getModuleLocal = (modules: Record<string, any>[]) => {
      let objectReturn: any = undefined;
      for (const item of modules) {
        if (item.module_url === module) {
          objectReturn = item;
          break;
        }
      }
      return objectReturn;
    };
    getModuleLocal(JSON.parse(modulesLocal));
    if (module !== null) {
      const moduleConfig = getModuleLocal(JSON.parse(modulesLocal));

      return (
        <div
          style={{
            marginLeft:
              localStorage.getItem("hiddenSidebar") === "true" ? "0px" : "203px",
          }}
          className={classNames("container")}
        >
          <div className="w-100">
            {}

            <DashboardCustomization module={module}>
              Bem-vindo ao módulo de{" "}
              <b
                style={{
                  textTransform: "capitalize",
                  color: moduleConfig.module_color,
                }}
              >
                {moduleConfig.module_full_name ?? moduleConfig.module_label}
              </b>
            </DashboardCustomization>
            {}
          </div>
        </div>
      );
    }
  }
}

export default withRouter(DashboardPage);
